import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {
    list: {},
  }
}

const state = getDefaultState()

const mutations = {
  SET_MENU_LISTS(state, payload) {
    state.list = payload
  },
}

const actions = {
  async updateOrCreate({ commit }, payload) {
    const apiResult = await apiService.post(route('member.project-plan-submission-documents.update-or-create'), payload)
    // FCS-904: バリデーションエラー (422) 時の errors を呼び出し元で赤い警告として表示できるよう、
    // apiService.post の結果オブジェクトをそのまま返す。
    // 成功時: {success:true, message, data} / 失敗時: {success:false, errorCode, data:{message, errors}}
    if (apiResult) {
      return apiResult
    }
  },
  async getDefaultMethodologies({ commit }, params) {
    const apiResult = await apiService.post(
      route('member.project-plan-submission-documents.get-default-methodologies'),
      params
    )
    if (apiResult.success) {
      return apiResult.data
    }
    return false
  },
  async getRecord({ commit }, params) {
    const apiResult = await apiService.post(route('member.project-plan-submission-documents.get-record'), params)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async getDataManagement({ commit }, params) {
    const apiResult = await apiService.post(
      route('member.project-plan-submission-documents.get-data-management'),
      params
    )
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async getAdditionalityInformation({ commit }, params) {
    const apiResult = await apiService.post(
      route('member.project-plan-submission-documents.get-additional-infomation'),
      params
    )
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async getMonitoringPlan({ commit }, params) {
    const apiResult = await apiService.post(
      route('member.project-plan-submission-documents.get-monitoring-plan'),
      params
    )
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async getSpecialNote({ commit }, params) {
    const apiResult = await apiService.post(route('member.project-plan-submission-documents.get-special-note'), params)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async write({ commit }, params) {
    const apiResult = await apiService.post(route('member.project-plan-submission-documents.write'), params)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async checkWriteStatus({ commit }, params) {
    const apiResult = await apiService.post(
      route('member.project-plan-submission-documents.check-write-status'),
      params
    )
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async uploadFile({ commit }, params) {
    const apiResult = await apiService.post(route('member.project-plan-submission-documents.upload-file'), params)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async getRegistrationApplication({ commit }, params) {
    const apiResult = await apiService.post(
      route('member.project-plan-submission-documents.get-registration-application'),
      params
    )
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
